import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IInvitePrincipal } from '../../shared/models/IInvitePrincipal';
import { ValidationService } from '../../shared/providers/validation.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { ToastService } from '../../shared/providers/toast.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { LoaderService } from '../../shared/providers/loader.service';

@Component({
  selector: 'app-invite-principal',
  templateUrl: './invite-principal.component.html',
  styleUrls: ['./invite-principal.component.css']
})
export class InvitePrincipalComponent implements OnInit {
  @Input() modalRefInvitePrincipal: BsModalRef;
  constructor(public Validation: ValidationService, public authService: AuthenticationService, private _userManagerService: UserManagerService, private _toastService: ToastService
    , private Loader: LoaderService) {
  }
  isSubmit = false;
  user: any;
  userExists: boolean = false;

  InvitePrincipalModal = {} as IInvitePrincipal;

  ngOnInit(): void {
    this.user = this.authService.user;
    this.InvitePrincipalModal.LoggedInUserId = this.user.Id;
  }

  doHide() {
    this.modalRefInvitePrincipal.hide();
  }
  saveInvitePrincpal() {
    this.isSubmit = true;
    let valid = true;

    if (this.Validation.IsinValid(this.InvitePrincipalModal.FirstName) ||
      this.Validation.IsinValid(this.InvitePrincipalModal.LastName) ||
      this.Validation.IsinValid(this.InvitePrincipalModal.EmailId) ||
      this.Validation.IsinValid(this.InvitePrincipalModal.PhoneNumber)
    ) {
      valid = false;
    }
    else if (!this.Validation.isEmail(this.InvitePrincipalModal.EmailId)) {
      valid = false;
    }
    if (valid && !this.userExists) {
      this.Loader.display(true);
      this.savePrincipal();
    }
  }

  savePrincipal() {
    this.InvitePrincipalModal.Source = "InvitePrincipal";
    this._userManagerService.SaveInvitePrincipal(this.InvitePrincipalModal).subscribe(response => {
      if (response) {
        this.Loader.display(false);
        this._toastService.addToast({ title: 'Success', msg: 'User Invited Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'Image could not be deleted',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
        this.Loader.display(false);
      }
      this.doHide();
    });
  }

  onEmailAddressChange() {
    if (this.InvitePrincipalModal.EmailId != '') {
      this._userManagerService.checkDuplicateUser(this.InvitePrincipalModal).subscribe(response => {
        if (response) {
          this.userExists = false;
        }
        else {
          this.userExists = true;
          this.Loader.display(false);
          this._toastService.addToast({ title: 'Error Occurred', msg: 'User with same email address exist in the system. Please contact the administrator.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      });
    }
  }
}
